<template>
  <aside class="flex flex-col divide-y divide-[#E4E7EC]">
    <slot />

    <SidebarFooter />
  </aside>
</template>

<script setup lang="ts">
//
</script>
